import { createContext } from 'react';

export type SelectionDataValue = {
    loading: boolean;
    total: number | null;
    currency: string;
    // Raw query result for the selection; narrowed by the body component per selection type.
    data: unknown;
};

export const SelectionDataContext = createContext<SelectionDataValue | null>(null);
